'use client';

import { BoxCTA } from '@lichtblick/photon/atoms/box-cta/box-cta';
import { Headline } from '@lichtblick/photon/atoms/headline/headline';
import { HeatingS } from '@lichtblick/photon/icons/energy/heating-s';
import { useTracker } from '@lichtblick/tracker';
import classNames from 'classnames';
import { type FC, useCallback, useEffect, useState } from 'react';
import type { CalculatorHeatingType } from '../../types/storyblok';
import { CityInput } from '../OAllInOneCalculator/CityInput';
import { useVpCodes } from '../OAllInOneCalculator/useVpCodes';
import styles from './calculator.module.scss';

export const CalculatorHeating: FC<CalculatorHeatingType> = ({ powerCloudCampaignId }) => {
  const [postcode, setPostcode] = useState('');
  const [city, setCity] = useState('');

  const { computeVpCodes } = useVpCodes();
  const { trackCustomEvent } = useTracker();

  const cityChangeHandler = useCallback((city: string, postcode: string) => {
    setCity(city);
    setPostcode(postcode);
  }, []);

  const [vpCodes, setVpCodes] = useState<{
    uvp?: string;
    vp?: string;
  }>({});

  useEffect(() => {
    setVpCodes(computeVpCodes());
  }, [computeVpCodes]);

  return (
    <form
      action="/waermestrom-checkout/"
      className={classNames(styles.form, styles.p2h)}
      id="waermestrom-calculator"
      method="GET"
      onSubmit={(e) => {
        if (e.currentTarget.checkValidity()) {
          trackCustomEvent({
            eventName: 'tariff_calculator_show_tariffs',
            customProps: { product: 'WärmeStrom', zip_code: postcode },
          });
        }
      }}
    >
      <Headline className={classNames(styles.headline, styles.p2h)} renderAs="h4" size="s">
        WärmeStrom
        <HeatingS />
      </Headline>
      <CityInput onChange={cityChangeHandler} />

      <input name="ort" type="hidden" value={city} />
      <input name="plz" type="hidden" value={postcode} />
      {Boolean(powerCloudCampaignId) && <input name="cam" type="hidden" value={powerCloudCampaignId} />}
      {Boolean(vpCodes.vp) && <input name="vp" type="hidden" value={vpCodes.vp} />}
      {Boolean(vpCodes.uvp) && <input name="uvp" type="hidden" value={vpCodes.uvp} />}

      <BoxCTA as="button" type="submit">
        Tarife berechnen
      </BoxCTA>
    </form>
  );
};
